module.exports = __webpack_public_path__ + "static/media/archived-default.8a13be7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/archived-default.svg
// module id = 1231
// module chunks = 0